import DownloadResy from './DownloadResy';

export default DownloadResy;
